import { ref } from 'vue'
import { defineStore } from 'pinia'
import { S3_POLICY_VERSION } from '@/configs/config'
import { formatBytes } from '@/utils/format.util'

export const useS3SettingsStore = defineStore('s3SettingsStore', {
  state: () => {
    const bucket = ref({
      name: '',
      createAt: '',
      endpoint: '',
      changedAt: undefined,
      type: undefined,
      size: undefined,
      numberObjects: undefined,
      numberIncompleteMultipart: 0,
      key: undefined,
      CORSRules: [],
      policy: {
        Version: S3_POLICY_VERSION,
        Statement: []
      }
    })

    const setBucketStats = (used_space = 0, numberObjects = 0, numberIncompleteMultipart = 0, usedMultipartsSpace = 0) => {
      bucket.value.size = formatBytes(used_space, 1)
      bucket.value.numberObjects = numberObjects
      bucket.value.numberIncompleteMultipart = numberIncompleteMultipart
      bucket.value.usedMultipartsSpace = formatBytes(usedMultipartsSpace, 1)
    }

    const setDefaultBucket = () => {
      bucket.value = {
        name: '',
        createAt: '',
        endpoint: '',
        changedAt: undefined,
        type: undefined,
        size: undefined,
        numberObjects: undefined,
        numberIncompleteMultipart: 0,
        key: undefined,
        CORSRules: [],
        policy: {
          Version: S3_POLICY_VERSION,
          Statement: []
        }
      }
    }

    const setBucketName = (name) => {
      bucket.value.name = name
    }

    return {
      bucket,
      setBucketName,
      setDefaultBucket,
      setBucketStats
    }
  }
})
